// extracted by mini-css-extract-plugin
export default {"notification":"Notification_notification__tRUcV","error":"Notification_error__v8EoA","success":"Notification_success__8sFDY"};